import { Modal } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { Text, Title } from 'components/mvp-typography';

/**
 * Displays a modal informing the user that the record is unavailable
 * until the test-taker accepts their invite.
 */
export function showRecordUnavailableModal() {
  Modal.info({
    title: <Title>Record Unavailable</Title>,
    content: (
      <Text>
        This record is unavailable until the user accepts their invite.
      </Text>
    ),
    footer: () => (
      <BaseButton onClick={() => Modal.destroyAll()}>Ok</BaseButton>
    ),
    centered: true,
    wrapClassName: 'root'
  });
}
